module.exports = __webpack_public_path__ + "img/power-motor.de4715d2.svg";